import { render, staticRenderFns } from "./y_choose_goods.vue?vue&type=template&id=d33ec8dc&scoped=true&"
import script from "./y_choose_goods.vue?vue&type=script&lang=js&"
export * from "./y_choose_goods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d33ec8dc",
  null
  
)

export default component.exports